import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";


const PrivacyPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title cp-page-title pt-120 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-center ">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">Privacy Policy</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="terms&conditions-section cp-det-bg">
          <div className="container">
            <div className="terms-section_inner pt-80 pb-75">
              <div className="row">
                <div className="col-lg-11">
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">Controller</h2>
                    <p>
                      TigrisPay Trading Company Ltd is registered as a data
                      controller with the UK Information Commissioner’s Office.
                    </p>
                    {/* <p>Certain types of data may be necessary to access and utilize specific features or services on this website. For example, contact information, account details, or preferences may be required to personalize the experience or enable specific functionalities</p> */}
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Who processes your Personal Data.
                    </h2>
                    <p>
                      We (TigrisPay) process and store Personal Data collected
                      from you via your use of the Service or where you have
                      given your consent.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      We might ask you to provide us with Personal Data
                    </h2>
                    <p>
                      TigrisPay may request that you provide Personal Data when
                      offering the Service to you. This Personal Data may
                      include:
                    </p>
                    <ul className="privacy-details">
                      <li>
                        Contact information such as name, title, email address,
                        mailing address and phone number.
                      </li>
                      <li>
                        Evidence of your identity e.g passport information
                      </li>
                      <li>
                        Unique identifiers such as user name, password, account
                        number
                      </li>
                      <li>Date of birth</li>
                    </ul>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      How we use your Personal Data
                    </h2>
                    <p>
                      TigrisPay uses Personal Data to communicate with you and
                      to administer, deliver, improve and personalise the
                      Service We may also use such data to communicate with you
                      in relation to other products or services offered by us.
                    </p>
                    <p>
                      We may request that you confirm your consent to receive
                      such communications (‘opt-in’) or to indicate that you
                      would not like to receive such communications or that they
                      should be discontinued (‘opt-out’). Where you opt-out, we
                      will not use your Personal Data for direct marketing. We
                      do not share your Personal Data with third parties (other
                      than partners in connection with their administrative or
                      technical services to TigrisPay).
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Sharing your Personal Data
                    </h2>
                    <p>We may share your Personal Data with third parties</p>
                    <ul className="privacy-details">
                      <li>
                        If we think that sharing it is necessary to enforce the
                        terms of a contract with you or to protect the rights,
                        property or safety of TigrisPay or the services provided
                        by us.
                      </li>
                      <li>
                        To enable us to comply with the law or to satisfy a
                        legitimate government request or an order of any court
                        of competent jurisdiction or any regulatory authority
                        or, if necessary, to defend TigrisPay or its Subscribers
                        (for example, in a lawsuit).
                      </li>
                      <li>
                        In connection with the sale or transfer of our business
                        or any part thereof.
                      </li>
                      <li>
                        To allow us to co-operate with law enforcement agencies
                        to identify anyone who uses our Service for illegal
                        activities. We reserve the right to report to law
                        enforcement agencies any activities that we believe are
                        unlawful including exchanging information with other
                        companies, organisations and agencies for the purposes
                        of fraud protection.
                      </li>
                      <li>
                        To third parties who provide services to TigrisPay (
                        such as administration or technical services). However,
                        we ensure that such partners do not use Personal Data
                        for any other purposes, do not disclose it to anyone
                        else and that they do not retain copies except as
                        necessary to provide services to us or as required by
                        law.
                      </li>
                    </ul>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      When you download our Mobile App, we may:
                    </h2>
                    <p>
                      Automatically collect information on the type of device
                      you use, operating system version, and system and
                      performance information. We may send you push
                      notifications from time-to-time in order to update you
                      about any events or promotions that we may be running. If
                      you no longer wish to receive these types of
                      communications, you may turn them off at the device level.
                      To ensure you receive proper notifications, we will need
                      to collect certain information about your device such as
                      operating system and user identification information;
                    </p>
                    <p>
                      May collect your location-based information for the
                      purpose of locating a place that you may be searching for
                      in your area. We will only share this information with our
                      mapping provider for the sole purpose of providing you
                      with this service. Your geo-location data may be shared
                      with third parties for the purpose of them serving you ads
                      for places (such as restaurants) in your area. You may
                      opt-out of location-based services at any time by editing
                      the setting at the device level or by emailing us at
                      <a href="mailto:hello@tigrispay.com">hello@tigrispay.com</a> and
                    </p>
                    <p>
                      May use mobile analytics software to allow us to better
                      understand the functionality of our Mobile Software on
                      Your phone. This software may record information such as
                      how often You use the Mobile App, the events that occur
                      within it, aggregated usage, performance data, and where
                      the Mobile App was downloaded from. We do not link the
                      information we store within the analytics software to any
                      personal data you submit within the Mobile App.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Storage, security and retention of your Personal Data
                    </h2>
                    <p>
                      Personal Data that we collect is stored on our secure
                      servers. We implement and maintain the highest levels of
                      security to protect any information stored on our servers
                      and to comply with all local rules.
                    </p>
                    <p>
                      It is your responsibility to keep your password secure.
                      You should also be aware that the The transmission of
                      information via the Internet is not completely secure.
                      Although we will do our best to protect your Personal
                      Data, we cannot guarantee the security of Personal Data
                      transmitted to our site outside our control.
                    </p>
                    <p>
                      We strive to collect no more Personal Data than is
                      required. This helps reduce the total risk of harm should
                      data loss or a breach in security occur. Your passwords
                      are stored on our server in encrypted form
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Notification in the event of breach
                    </h2>
                    <p>
                      It would be very unlikely, but if a breach in the security
                      of Personal Data were to occur, we will notify you if you
                      are actually or potentially affected. In this event we
                      will contact you via email or in-Service messaging. We
                      reserve the right to delay notification if it is asked to
                      do so by law enforcement or other authorities, or if
                      giving notice immediately will increase the risk of harm
                      to end-users overall.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Links to other websites
                    </h2>
                    <p>
                      Our website includes links to other Web sites whose
                      privacy practices may differ from ours. If you submit
                      personal information to any of those sites, your
                      information is governed by their privacy policies. We
                      advise you to carefully read the privacy policy of any Web
                      site you visit.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Contact Information
                    </h2>
                    <p>
                      <Link
                        onClick={ClickHandler}
                        to="/contact"
                        className="details-link"
                      >
                        Click here
                      </Link>{" "}
                      to contact us regarding this Terms & Conditions or other
                      related issues. You can also send us an e-mail <br /> on: 
                      <a href="mailto:hello@tigrispay.com">hello@tigrispay.com</a>
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Privacy Policy changes
                    </h2>
                    <p>
                      TigrisPay may change this Privacy Policy at any time by
                      posting the revised policy on its website. Any changes
                      will become effective immediately upon being posted unless
                      stated otherwise.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CtaSection cClassNamclassName={"bg"} />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default PrivacyPage;
